import { render, staticRenderFns } from "./balanceUslugaList.vue?vue&type=template&id=53c44e3f&"
import script from "./balanceUslugaList.vue?vue&type=script&lang=js&"
export * from "./balanceUslugaList.vue?vue&type=script&lang=js&"
import style0 from "./balanceUslugaList.vue?vue&type=style&index=0&id=53c44e3f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports